import React, { useState } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import toast from "react-hot-toast";
import ImageUploader from "../utils/imgUploader";
import { useCreateTestimonial } from "../../hooks/useCreateTestimonial";

const TestimonialForm = ({showModal}) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    comment: "",
    address: "",
    organization: "",
    img: null,
  });
  const [loading, setLoading] = useState(false);

  const { mutate } = useCreateTestimonial({
    onSuccessCallback: () => {
      setFormData({
        name: "",
        email: "",
        phone: "",
        comment: "",
        address: "",
        organization: "",
        img: null,
      });
      setLoading(false);
      toast.success("Your details is being submitted");
      showModal()
    },
    onErrorCallback: (errorMsg) => {
      setLoading(false);
      toast.error(errorMsg);
      showModal()
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhoneChange = (value) => {
    setFormData((prev) => ({ ...prev, phone: value }));
  };
  const handleImageSelect = (file) => {
    setFormData((prev) => ({ ...prev, img: file }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const sendData = new FormData();
    sendData.append("name", formData.name);
    sendData.append("email", formData.email ?? "");
    sendData.append("mobile", formData.phone ?? "");
    sendData.append("address", formData.address ?? "");
    sendData.append("organization", formData.organization ?? "");
    sendData.append("comments", formData.comment);

    // Handle image file
    if (formData.img && formData.img instanceof File) {
      sendData.append("img", formData.img); // actual file
    }

    mutate({
      data: sendData,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="mt-5 flex flex-col gap-4 w-full">
      {/* Name */}
      <div className="flex flex-col items-start gap-3 ">
        <label className="text-16 text-headingtext font-medium">Name*</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Enter Name"
          className="text-16 border-[1px] border-[#CED0D6] rounded-[16px] px-3 py-3  focus:outline-none focus:border-gray-500 w-full"
          required
        />
      </div>
      {/* Email Address */}
      <div className="flex flex-col items-start gap-3 ">
        <label className="text-16 text-headingtext font-medium">
          Email Address
        </label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Enter your email ID"
          className="text-16 border-[1px] border-[#CED0D6] rounded-[16px] px-3 py-3 focus:outline-none focus:border-gray-500 w-full"
        />
      </div>

      {/* Phone Number */}
      <div className="flex flex-col items-start gap-3 ">
        <label className="text-16 text-headingtext font-medium">
          Phone Number*
        </label>
        <div className="w-full relative flex border-[1px] border-[#CED0D6] rounded-[16px] focus-within:border-gray-500 w-full">
          <PhoneInput
            name="phone"
            defaultCountry="AU"
            value={formData.phone}
            onChange={handlePhoneChange}
            placeholder="Enter your phone number"
            className="text-16 px-3 py-3 focus:outline-none focus:border-gray-500 outline-none ml-2 border-[#CED0D6] w-full"
            required
          />
        </div>
      </div>
      {/* Address */}
      <div className="flex flex-col items-start gap-3 ">
        <label className="text-16 text-headingtext font-medium">Address*</label>
        <input
          type="text"
          name="address"
          value={formData.address}
          onChange={handleChange}
          placeholder="Enter Address"
          className="text-16 border-[1px] border-[#CED0D6] rounded-[16px] px-3 py-3  focus:outline-none focus:border-gray-500 w-full"
          required
        />
      </div>
      {/* organization */}
      <div className="flex flex-col items-start gap-3 ">
        <label className="text-16 text-headingtext font-medium">
          organization
        </label>
        <input
          type="text"
          name="organization"
          value={formData.organization}
          onChange={handleChange}
          placeholder="Enter Your organization"
          className="text-16 border-[1px] border-[#CED0D6] rounded-[16px] px-3 py-3  focus:outline-none focus:border-gray-500 w-full"
        />
      </div>

      {/* We’re Listening */}
      <div className="flex flex-col items-start gap-3 ">
        <label className="text-16 text-headingtext font-medium">Comment*</label>
        <textarea
          name="comment"
          value={formData.comment}
          onChange={handleChange}
          rows="4"
          required
          placeholder="Share your thoughts..."
          className="text-16 border-[1px] border-[#CED0D6] rounded-[16px] px-3 py-3  focus:outline-none focus:border-gray-500 w-full "
        />
      </div>

      {/* ImageUploader Component */}
      <div className="flex flex-col items-start gap-3 w-full">
        <label className="text-16 text-headingtext font-medium">
          Profile Image
        </label>
        <ImageUploader onImageSelect={handleImageSelect} />
      </div>

      {/* Submit Button */}
      <div className=" flex flex-col gap-8 justify-between">
        <button
          disabled={loading}
          type="submit"
          className="bg-[#002DA3] text-white font-bold px-6 py-3 rounded-[32px] hover:bg-blue-700 transition duration-300"
        >
          {" "}
          {loading ? "Submitting..." : "Submit"}
        </button>
      </div>
    </form>
  );
};

export default TestimonialForm;
